import * as XLSX from 'xlsx';

export const createPayrollTemplate = () => {
  // Create workbook
  const wb = XLSX.utils.book_new();
  
  // Simple data structure with headers only
  const templateData = [
    ['PAYROLL SUMMARY - January 16-31, 2025'],
    [],
    ['Employee', 'Daily Rate', 'Total Hours', 'Overtime Hours', 'Basic Pay', 'Holiday Pay', 'Incentives', 'Other Bonuses', 'TOTAL GROSS', 'SSS', 'Pagibig', 'Philhealth', 'CA', 'Loan Deduction', 'Other Deductions', 'TOTAL GROSS DEDUCTIONS', 'NET PAY'],
    // Empty rows for data entry
    ['', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', ''],
    ['', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', ''],
    ['', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', ''],
    ['', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', ''],
    ['', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', ''],
    ['', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', ''],
    ['', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', ''],
    ['', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', ''],
    ['', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', ''],
    ['', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', ''],
    ['', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', ''],
    ['', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '']
  ];

  // Create worksheet
  const ws = XLSX.utils.aoa_to_sheet(templateData);

  // Set column widths for better readability
  const colWidths = [
    { wch: 25 }, // Employee
    { wch: 12 }, // Daily Rate
    { wch: 12 }, // Total Hours
    { wch: 15 }, // Overtime Hours
    { wch: 12 }, // Basic Pay
    { wch: 12 }, // Holiday Pay
    { wch: 12 }, // Incentives
    { wch: 15 }, // Other Bonuses
    { wch: 15 }, // TOTAL GROSS
    { wch: 10 }, // SSS
    { wch: 10 }, // Pagibig
    { wch: 12 }, // Philhealth
    { wch: 10 }, // CA
    { wch: 15 }, // Loan Deduction
    { wch: 15 }, // Other Deductions
    { wch: 20 }, // TOTAL GROSS DEDUCTIONS
    { wch: 12 }  // NET PAY
  ];
  ws['!cols'] = colWidths;

  // Add the worksheet to workbook
  XLSX.utils.book_append_sheet(wb, ws, 'Payroll');

  // Generate buffer
  const wbout = XLSX.write(wb, { type: 'buffer', bookType: 'xlsx' });
  return wbout;
}; 